module.exports = __webpack_public_path__ + "img/eth-dark-navy.ad11058d.svg";